import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const CompanyDetails = ({ companyProfile }) => {
  return (
    <div className="col-lg-9">
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Company Basic Info</h4>
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="profile-info-list">
                <ul>
                  <li>
                    Company Name: <span>{companyProfile?.company_name}</span>
                  </li>
                  <li>
                    Email: <span>{companyProfile?.email}</span>
                  </li>
                  <li>
                    Contact Number: <span>{companyProfile?.contact_number}</span>
                  </li>
                  <li>
                    Registration Number:{" "}
                    <span>{companyProfile?.comp_registration_number}</span>
                  </li>
                  <li>
                    Company Website:{" "}
                    <span>
                      <a
                        href={companyProfile?.company_website}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {companyProfile?.company_website}
                      </a>
                    </span>
                  </li>
                  <li>
                    Working Hours:<span>{companyProfile?.working_hours}</span>
                  </li>
                  <li>
                    Working Days:<span>{companyProfile?.working_days}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="profile-info-list">
                <ul>
                  <li>
                    Team Size: <span>{companyProfile?.team_size}</span>
                  </li>
                  <li>
                    Established: <span>{companyProfile?.established_in}</span>
                  </li>
                  <li>
                    Primary Industry:{" "}
                    <span>{companyProfile?.primary_industry}</span>
                  </li>
                  <li>
                    Join Year:{" "}
                    <span>{new Date(companyProfile?.created_at).getFullYear()}</span>

                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">About Company</h4>
          <div className="col-lg-12">
            <div className="profile-bio">
              <p>{companyProfile?.about_company}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Company tagline</h4>
          <div className="col-lg-12">
            <div className="profile-bio">
              <p>{companyProfile?.tagline}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Contact Info</h4>
          <div className="col-lg-">
            <div className="profile-info-list">
              <ul>
                <li className="d-flex justify-content-between align-items-start">
                  <strong className="me-2">Address:</strong>
                  <span className="text-end text-break flex-grow-1">{companyProfile?.address || 'N/A'}</span>
                </li>

                <li>
                  City: <span>{companyProfile?.city}</span>
                </li>
                <li>
                  State: <span>{companyProfile?.state}</span>
                </li>
                <li>
                  Post Code: <span>{companyProfile?.zip_code}</span>
                </li>
                <li>
                  Country: <span>{companyProfile?.country}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Social Network</h4>
          <div className="col-lg-6">
            <div className="profile-social">
              {companyProfile.facebook && <a
                href={companyProfile?.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f" />
              </a>}
              {companyProfile.twitter && <a
                href={companyProfile?.twitter}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter" />
              </a>}
              {companyProfile.linkedin && <a
                href={companyProfile?.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in" />
              </a>}
              {companyProfile.pinterest && <a
                href={companyProfile?.pinterest}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-pinterest" />
              </a>}
              {companyProfile.whatsapp && <a
                href={companyProfile.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp" />
              </a>}
              {companyProfile.instagram && <a
                href={companyProfile.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram" />
              </a>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;
